import OrderSummary from "./Cart/OrderSummary";
import CartUpsells from "./Upsells/CartUpsells";

const { __ } = window.wp.i18n;
const { registerPlugin } = window.wp.plugins;
const { ExperimentalOrderMeta, registerCheckoutFilters } = window.wc.blocksCheckout;

const render = () => {

	// Early return where aren't on the checkout page.
	if ( ! document.body.classList.contains( 'woocommerce-checkout' ) ) {
		return null;
	}

	// Render Zap Checkout Order Summary + Upsells.
	return (
		<ExperimentalOrderMeta>
			<OrderSummary />
			<CartUpsells />
		</ExperimentalOrderMeta>
	);
}

// Add Zap Checkout Upsells to WooCommerce Checkout blocks.
if ( ! window.zapCheckoutRegistered ) {
	registerPlugin( 'zap-checkout-upsells', {
		render,
		scope: 'woocommerce-checkout'
	});

	const placeOrderButtonText = (_default_text, _extensions) => {
		return "Place Order";
	};

	// Ensure place order button text is not overwritten by DNA.
	registerCheckoutFilters( 'zap-place-order-button-text', {
		placeOrderButtonLabel: placeOrderButtonText
	} );

	// Safari's AutoFill (QuickType / contact card) sets field values directly
	// via the native DOM setter without firing the 'input' event the block
	// checkout listens on, so React's state — and the payload posted to the
	// Store API — stays empty even though the field looks filled. Every path
	// to placing the order fires a native 'submit' on the checkout form, so
	// resyncing there in the capture phase (before the block's own bubble-phase
	// onSubmit runs) covers both clicking Place Order and hitting Enter/Go.
	if ( document.body.classList.contains( 'woocommerce-checkout' ) ) {
		document.addEventListener(
			'submit',
			() => {
				document.querySelectorAll( 'input[autocomplete]' ).forEach( ( field ) => {
					field.dispatchEvent( new Event( 'input', { bubbles: true } ) );
				} );
			},
			{ capture: true }
		);
	}

	window.zapCheckoutRegistered = true;
}